import { useRef } from 'react';
import classes from './SlLessonContent.module.css'
import { useSelector } from "react-redux";
import StorylinePlayer from '../../lms-shared/LessonViewer/Tabs/Learning/StorylinePlayer';
import { useParams } from 'react-router-dom';

const SlLessonContent = ({ materialContentPath, saveFile }) => {

    const texts = useSelector(state => state.translate.texts);
    const fileType = 'zip';
    const ref = useRef();
    const user = useSelector((state) => state.auth.user);
    const { id, guid } = useParams();

    const handleFileReader = async (e) => {
        if (e.target.files.length > 0) {
            if (e.target.files[0].name.split('.').pop() !== fileType) {
                alert(`can only upload ${fileType} files`)
            }
            else {
                saveFile(e.target.files[0], ref)
            }
        }
    }

    return (
        <div className={classes.CreateLesson}>
            <div className={classes.HeaderContainer}>
                <div> {texts.chooseFile}</div>
                <div className={classes.FileInputContainer}>
                    <div className={classes.FileInputWarrper}>  {texts.import}
                        <input className={classes.FileInput} onChange={handleFileReader} type="file" accept={`.${fileType}`} id="FileInput" />
                    </div>
                </div>
            </div>
            <div className={classes.ShowPreviewWrapper}>
                <div className={classes.Text}>{texts.showPreview}</div>
                <div className={classes.ShowPreview}>
                    {materialContentPath &&
                        <StorylinePlayer contentDirPath={materialContentPath} lessonId={guid} studyGroupId={id} />}
                </div>
            </div>
        </div>
    )
}
export default SlLessonContent